import { createApiClientContext } from '@wix/package-picker-shared';
const studioOfferingApiClientContext = {};
export const StudioOfferingApiClientContext = createApiClientContext(studioOfferingApiClientContext);
//# sourceMappingURL=studio-offering.context.js.map